import {
  TournamentSegment,
  getSegmentMatchIds,
} from "model/Tournament/Segment/TournamentSegment";
import { PickemDetails, PickemDetailsBase } from "../PickemDetails";
import { MatchemPointsRules } from "./PointsRules";

export type MatchemDetails = PickemDetailsBase & {
  pointsRules: MatchemPointsRules;
  subSegmentNum: number | undefined;
};

export const isMatchemDetails = (
  pickemDetails: PickemDetails
): pickemDetails is MatchemDetails => {
  return pickemDetails.pickemType === "Matchem";
};

export const getMatchemMatchIds = (
  matchemDetails: MatchemDetails,
  segment: TournamentSegment
) => {
  if (matchemDetails.subSegmentNum !== undefined) {
    // return getSubSegmentMatchIds(segment, matchemDetails.subSegmentNum);
  }

  return getSegmentMatchIds(segment);
};

export const getMatchemPriorMatchIds = (
  matchemDetails: MatchemDetails,
  segment: TournamentSegment
) => {
  if (!matchemDetails.subSegmentNum) {
    return undefined;
  }

  // if (segment.type === "Season") {
  //   return getPreviousPlaydayMatchIds(segment, matchemDetails.subSegmentNum);
  // }

  // if (segment.type === "Swiss") {
  //   return getPreviousRoundMatchIds(segment, matchemDetails.subSegmentNum);
  // }
};
